(() => {
  const pad = (n) => (n < 10 ? '0' + n : String(n));

  class ShProductCollection extends HTMLElement {
    connectedCallback() {
      this.initCountdown();
      this.initRail();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    /* ---------- countdown ---------- */

    initCountdown() {
      this.clock = this.querySelector('[data-countdown]');
      if (!this.clock) return;

      // Target is computed server-side in shop time, so every visitor counts
      // down to the same moment regardless of their own timezone.
      this.target = Number(this.clock.dataset.target) * 1000;
      this.weekly = this.clock.dataset.mode === 'weekly';
      this.parts = {
        days: this.clock.querySelector('[data-days]'),
        hours: this.clock.querySelector('[data-hours]'),
        minutes: this.clock.querySelector('[data-minutes]'),
        seconds: this.clock.querySelector('[data-seconds]'),
      };

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      let left = this.target - Date.now();

      if (left <= 0) {
        if (!this.weekly) {
          clearInterval(this.timer);
          this.clock.hidden = true;
          return;
        }
        // Rolled past Monday 00:00 — jump to the next one
        this.target += 7 * 24 * 60 * 60 * 1000;
        left = this.target - Date.now();
      }

      const s = Math.floor(left / 1000);
      this.parts.days && (this.parts.days.textContent = pad(Math.floor(s / 86400)));
      this.parts.hours && (this.parts.hours.textContent = pad(Math.floor((s % 86400) / 3600)));
      this.parts.minutes && (this.parts.minutes.textContent = pad(Math.floor((s % 3600) / 60)));
      this.parts.seconds && (this.parts.seconds.textContent = pad(s % 60));
    }

    /* ---------- mobile rail dots ---------- */

    initRail() {
      this.rail = this.querySelector('[data-rail]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (!this.rail || !this.dots.length) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const card = this.rail.children[index];
          if (card) this.rail.scrollTo({ left: card.offsetLeft - this.rail.offsetLeft, behavior: 'smooth' });
        });
      });

      this.rail.addEventListener('scroll', () => this.syncDots(), { passive: true });
      this.syncDots();
    }

    syncDots() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const steps = this.dots.length - 1;
      const active = max > 1 && steps > 0 ? Math.round((this.rail.scrollLeft / max) * steps) : 0;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
    }
  }

  if (!customElements.get('sh-product-collection')) {
    customElements.define('sh-product-collection', ShProductCollection);
  }
})();
